export const THEMES = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  NATURE: 'NATURE',
  PLUNJR: 'PLUNJR',
  SENTINELS: 'SENTINELS',
};
